"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _ThemeContext = _interopRequireDefault(require("./ThemeContext"));
var _excluded = ["forwardedRef"];
var _jsxFileName = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/withThemeConsumer.js",
  _this = void 0;
function cov_hchkf262r() {
  var path = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/withThemeConsumer.js";
  var hash = "1e78dd140c3bc7728a6ac4a9074730a22228e816";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/withThemeConsumer.js",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 26
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 12,
          column: 20
        },
        end: {
          line: 18,
          column: 3
        }
      },
      "2": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 28
        }
      },
      "3": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 86
        }
      },
      "4": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 21,
          column: 16
        }
      },
      "5": {
        start: {
          line: 20,
          column: 39
        },
        end: {
          line: 20,
          column: 82
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 26
          },
          end: {
            line: 10,
            column: 27
          }
        },
        loc: {
          start: {
            line: 10,
            column: 63
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 20
          },
          end: {
            line: 12,
            column: 21
          }
        },
        loc: {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 17,
            column: 28
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 14,
            column: 7
          },
          end: {
            line: 14,
            column: 8
          }
        },
        loc: {
          start: {
            line: 15,
            column: 8
          },
          end: {
            line: 15,
            column: 86
          }
        },
        line: 15
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 23
          },
          end: {
            line: 20,
            column: 24
          }
        },
        loc: {
          start: {
            line: 20,
            column: 39
          },
          end: {
            line: 20,
            column: 82
          }
        },
        line: 20
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 9
          },
          end: {
            line: 21,
            column: 15
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 20,
            column: 83
          }
        }, {
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 21,
            column: 15
          }
        }],
        line: 19
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1e78dd140c3bc7728a6ac4a9074730a22228e816"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_hchkf262r = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_hchkf262r();
/**
 * A higher-order component (HOC) that injects theme context into the wrapped component.
 * @param {React.ComponentType} WrappedComponent - The component to be wrapped.
 * @param {boolean} useForwardRef - The boolean to decide the forward ref props.
 * @returns {React.ComponentType} - The wrapped component with theme context injected.
 */
cov_hchkf262r().s[0]++;
var withThemeConsumer = function withThemeConsumer(WrappedComponent, useForwardRef) {
  cov_hchkf262r().f[0]++;
  cov_hchkf262r().s[1]++;
  // eslint-disable-next-line react/prop-types
  var Component = function Component(_ref) {
    var forwardedRef = _ref.forwardedRef,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    cov_hchkf262r().f[1]++;
    cov_hchkf262r().s[2]++;
    return /*#__PURE__*/_react.default.createElement(_ThemeContext.default.Consumer, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 13,
        columnNumber: 5
      }
    }, function (themeContext) {
      cov_hchkf262r().f[2]++;
      cov_hchkf262r().s[3]++;
      return /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({}, props, {
        themeContext: themeContext,
        ref: forwardedRef,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 15,
          columnNumber: 9
        }
      }));
    });
  };
  cov_hchkf262r().s[4]++;
  return useForwardRef ? (cov_hchkf262r().b[0][0]++, /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
    cov_hchkf262r().f[3]++;
    cov_hchkf262r().s[5]++;
    return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
      forwardedRef: ref,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20,
        columnNumber: 40
      }
    }));
  })) : (cov_hchkf262r().b[0][1]++, Component);
};
var _default = exports.default = withThemeConsumer;